import { createContext, useContext } from 'react';
import { SettingsContextProps } from 'src/components/settings';
import { defaultSettings } from 'src/components/settings/config';
import { defaultPreset } from 'src/components/settings/presets';

export const initialState: SettingsContextProps = {
  ...defaultSettings,
  changeTheme: () => null,
  // Mode
  onToggleMode: () => null,
  onChangeMode: () => null,
  // Direction
  onToggleDirection: () => null,
  onChangeDirection: () => null,
  onChangeDirectionByLang: () => null,
  // Layout
  onChangeLayout: () => null,
  // Contrast
  onToggleContrast: () => null,
  onChangeContrast: () => null,
  // Color
  onChangeColorPresets: () => null,
  presetsColor: defaultPreset,
  presetsOption: [],
  // Stretch
  onToggleStretch: () => null,
  // Reset
  onResetSetting: () => null,
};

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);

  if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider');

  return context;
}; // ----------------------------------------------------------------------

export const SettingsContext = createContext(initialState);
